@let walkthrough = guide.walkthrough();
@let target = guide.currentTarget();
@if (walkthrough && target && layout(); as spot) {
  <div class="guide-spotlight" [class.guide-spotlight--static]="reducedMotion()" data-guide-spotlight>
    <div
      class="guide-spotlight__ring"
      aria-hidden="true"
      [style.top.px]="spot.ring.top"
      [style.left.px]="spot.ring.left"
      [style.width.px]="spot.ring.width"
      [style.height.px]="spot.ring.height"
    ></div>

    <div
      class="guide-spotlight__finger"
      [class.guide-spotlight__finger--down]="spot.finger.pointing === 'down'"
      aria-hidden="true"
      data-guide-finger
      [attr.data-pointing]="spot.finger.pointing"
      [style.top.px]="spot.finger.top"
      [style.left.px]="spot.finger.left"
    >
      <svg class="guide-spotlight__hand" viewBox="0 0 48 48" width="48" height="48" focusable="false">
        <g class="guide-spotlight__hand-outline">
          <rect x="17" y="3" width="9" height="27" rx="4.5" />
          <rect x="24.5" y="16.5" width="8" height="11" rx="4" />
          <rect x="31" y="19" width="7" height="11" rx="3.5" />
          <rect x="13" y="20" width="25" height="21" rx="7.5" />
          <rect x="6" y="24.5" width="13" height="7" rx="3.5" transform="rotate(-28 12.5 28)" />
        </g>
        <g class="guide-spotlight__hand-fill">
          <rect x="17" y="3" width="9" height="27" rx="4.5" />
          <rect x="24.5" y="16.5" width="8" height="11" rx="4" />
          <rect x="31" y="19" width="7" height="11" rx="3.5" />
          <rect x="13" y="20" width="25" height="21" rx="7.5" />
          <rect x="6" y="24.5" width="13" height="7" rx="3.5" transform="rotate(-28 12.5 28)" />
        </g>
        <path class="guide-spotlight__hand-crease" d="M24.5 20.5v5M31 21.5v5" />
        <rect class="guide-spotlight__hand-nail" x="19" y="5" width="5" height="4.5" rx="2.2" />
        <rect class="guide-spotlight__hand-cuff" x="15" y="39.5" width="21" height="6.5" rx="2.5" />
      </svg>
    </div>

    <div
      #tooltip
      class="guide-spotlight__tooltip"
      role="dialog"
      tabindex="-1"
      [attr.aria-label]="'setupGuide.spotlight.label' | t"
      aria-describedby="guide-spotlight-tip"
      data-guide-tooltip
      [style.top.px]="spot.tooltip.top"
      [style.left.px]="spot.tooltip.left"
      [style.width.px]="spot.tooltip.width"
    >
      <p class="guide-spotlight__count">{{ countLabel(walkthrough.index, walkthrough.targets.length) }}</p>
      <p id="guide-spotlight-tip" class="guide-spotlight__tip" aria-live="polite">{{ target.tipKey | t }}</p>
      <div class="guide-spotlight__actions">
        <button type="button" class="guide-spotlight__skip" (click)="skip()">{{ 'setupGuide.spotlight.skip' | t }}</button>
        <button type="button" class="guide-spotlight__next" (click)="next()">
          {{ (guide.isLast() ? 'setupGuide.spotlight.done' : 'setupGuide.spotlight.next') | t }}
        </button>
      </div>
    </div>
  </div>
}

@if (guide.fallbackTip(); as tip) {
  <div class="guide-spotlight__toast" role="status" aria-live="polite" data-guide-toast>
    <span class="material-symbols-outlined" aria-hidden="true">lightbulb</span>
    <p>{{ tip | t }}</p>
    <button type="button" [attr.aria-label]="'common.close' | t: 'Close'" (click)="guide.dismissFallback()">
      <span class="material-symbols-outlined" aria-hidden="true">close</span>
    </button>
  </div>
}
